import { render, staticRenderFns } from "./ProjectFrame.vue?vue&type=template&id=84adf048&scoped=true&"
import script from "./ProjectFrame.vue?vue&type=script&lang=js&"
export * from "./ProjectFrame.vue?vue&type=script&lang=js&"
import style0 from "./ProjectFrame.vue?vue&type=style&index=0&id=84adf048&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84adf048",
  null
  
)

export default component.exports